import { Modal, Row, Col, Button, Container } from 'react-bootstrap';
import React from 'react';
import { FaWindowClose } from 'react-icons/fa';
import { format } from '~/Utils/Helpers';

const ModalDetalhesDocDigital = ({
  linhaSelecionada,
  mostrarModal,
  setMostrarModal,
}) => {
  return (
    <Modal
      show={mostrarModal}
      onHide={() => setMostrarModal(false)}
      size={'xl'}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Detalhes</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="p-0"
        style={{
          maxHeight: '70vh',
          overflowY: 'auto',
        }}
      >
        <div className="mt-1">
          <Container fluid>
            <label>Documento Digital</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Código</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.codigo}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Data Solicitação</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {format.date(linhaSelecionada.data_solicitacao)}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={12}>
                <small>Tipo Documento</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.tipo_doc_digital}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Solicitante</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.nome_solicitante}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Depto. Solicitante</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.departamento_solicitante}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Status</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.status}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Motivo Cancelamento</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.motivo_cancelamento === null
                    ? 'Sem cancelamento'
                    : linhaSelecionada.motivo_cancelamento}
                </strong>
              </Col>
            </Row>
            <hr />
            <label>Cliente</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Nome</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.nome_cliente}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>CPF</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {format.cpf(linhaSelecionada.cpf_cliente)}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>GE</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.ge}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Conta</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.conta}
                </strong>
              </Col>
            </Row>
            <hr />
            <label>Empreendimento</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Nome</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.empreendimento}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Pré-venda</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.pre_venda}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Quadra</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.quadra}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Lote</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.lote}
                </strong>
              </Col>
            </Row>
            <hr />
            <label>Pendências</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Grupo Pendente</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.grupo_pendente === null
                    ? 'Sem pendência'
                    : linhaSelecionada.grupo_pendente}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Assinatura Pendente</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.assinatura_pendente === null
                    ? 'Sem pendência'
                    : linhaSelecionada.assinatura_pendente}
                </strong>
              </Col>
            </Row>
            <hr />
            <label>Participantes</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Aprovador</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.aprovador === null
                    ? 'Sem aprovador'
                    : linhaSelecionada.aprovador}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Procurador</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.procurador === null
                    ? 'Sem procurador'
                    : linhaSelecionada.procurador}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>1° Testemunha</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.primeira_testemunha === null
                    ? 'Sem 1° Testemunha'
                    : linhaSelecionada.primeira_testemunha}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>2° Testemunha</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.segunda_testemunha === null
                    ? 'Sem 2° Testemunha'
                    : linhaSelecionada.segunda_testemunha}
                </strong>
              </Col>
            </Row>
            <hr />
            <label>Dias para Aprovação</label>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Qtd Dias Aprovador</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.dias_aprovador}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Qtd Dias Procurador</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.qtd_dias_procurador}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Qtd Dias 1° Testemunha</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.qtd_dias_primeira_testemunha}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Qtd Dias 2° Testemunha</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.qtd_dias_segunda_testemunha}
                </strong>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={6} sm={4} xs={6}>
                <small>Qtd Dias Cliente</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.qtd_dias_clientes}
                </strong>
              </Col>
              <Col md={6} sm={4} xs={6}>
                <small>Total Dias</small>
                <strong className="d-block" style={{ fontSize: 'smaller' }}>
                  {linhaSelecionada.total_dias}
                </strong>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <>
          <Button
            variant={'light'}
            type="submit"
            className="d-inline-flex align-items-center"
            onClick={() => {
              setMostrarModal(false);
            }}
          >
            <FaWindowClose />
            <span className="ml-2 d-xs-none">Fechar</span>
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalhesDocDigital;
